import React, { FC } from 'react';
import cx from 'classnames';

import useThemeBlock from '@/hooks/useThemeBlock';
import { CardLinkProps } from '@/helpers/CardControls/typings';
import { Link } from '@/helpers/Link/render';
import { Image } from '@/components/molecules/Image/render';

import block from './block.json';
import { getStyles } from './styles.css';

/**
 * TYPINGS
 */
export type CardKeyfactIconProps = {
	image?: ImageProps;
	label: string;
	link?: CardLinkProps;
} & ThemeProps;

/**
 * COMPONENT
 */
export const CardKeyfactIcon: FC<CardKeyfactIconProps> & BlockConfigs = ({
	image,
	label,
	link: { href = null, opensInNewTab = false, ...linkProps } = {},
	theme = {},
}) => {
	const { variant, blockTheme } = useThemeBlock(block.slug, theme);

	const htmlProps = {
		'data-variant': variant,
	};

	const rootClass = cx(
		'supt-card supt-cardKeyfact supt-cardKeyfact--icon',
		getStyles(blockTheme),
		href && 'supt-withLink'
	);

	return (
		<div className={rootClass} data-block={block.slug} {...htmlProps}>
			{image?.src && (
				<div className="supt-cardKeyfact__imageWrapper">
					<Image {...image} className="supt-cardKeyfact__image" />
				</div>
			)}
			{href ? (
				<Link
					href={href}
					className="supt-cardKeyfact__label supt-cardKeyfact__link"
					{...(opensInNewTab && {
						target: '_blank',
						rel: 'noopener noreferrer',
					})}
					dangerouslySetInnerHTML={{ __html: label }}
					{...linkProps}
				/>
			) : (
				<p
					className="supt-cardKeyfact__label"
					dangerouslySetInnerHTML={{ __html: label }}
				/>
			)}
		</div>
	);
};

CardKeyfactIcon.slug = block.slug;
CardKeyfactIcon.title = block.title;
